import { Component, OnInit } from '@angular/core';
import { JumpPageService } from 'src/app/_share/service/jump-page.service';

@Component({
  selector: 'app-government',
  templateUrl: './government.component.html',
  styleUrls: ['./government.component.less']
})
export class GovernmentComponent implements OnInit {

  constructor(
    private _jumpPage: JumpPageService,
  ) { }

  public governmentTitle = 'product.government.governmentTitle'; // 标题
  public governmentDesc = 'product.government.governmentDesc'; //描述
  public governmentBtn = 'product.government.governmentBtn'; 
  public governmentImgSrc = './assets/img/government/government-background.png'; //背景图
  public governmentLink = 'https://app.oatos.com/os/#/welcome/sign-up'; //链接地址

  public caseContent: Array<any> = [
    {
      imgUrl: './assets/img/government/government-case-img1.png'
    },
    {
      imgUrl: './assets/img/government/government-case-img2.png'
    },
    {
      imgUrl: './assets/img/government/government-case-img3.png'
    }
  ]

  public featureTitle = 'product.government.featureTitle';
  public featureDesc = 'product.government.featureDesc';

  public customizeTitle = 'product.government.customizeTitle';
  public customizeContent: Array<any> = [
    {
      imgUrl: './assets/img/government/government-customize-img1.png',
      title: 'product.government.customizeContent-title1',
      desc: 'product.government.customizeContent-desc1'
    },
    {
      imgUrl: './assets/img/government/government-customize-img2.png',
      title: 'product.government.customizeContent-title2',
      desc: 'product.government.customizeContent-desc2'
    },
    {
      imgUrl: './assets/img/government/government-customize-img3.png',
      title: 'product.government.customizeContent-title3',
      desc: 'product.government.customizeContent-desc3'
    },
    {
      imgUrl: './assets/img/government/government-customize-img4.png',
      title: 'product.government.customizeContent-title4',
      desc: 'product.government.customizeContent-desc4'
    }
  ]

  ngOnInit(): void {
    this._jumpPage.goTop();
  }

}
